import { ICellConfig } from "./types";

export function getBlockRange(block1: ClientRect, block2: ClientRect, isXLayout = true) {
	if (isXLayout) {
		return {
			min: block1.left + window.pageXOffset,
			max: block2.right + window.pageXOffset,
		};
	}
	return {
		min: block1.top + window.pageYOffset,
		max: block2.bottom + window.pageYOffset,
	};
}

export function getMarginSize(config: ICellConfig, xLayout: boolean) {
	if (!config) {
		return 0;
	}
	if (config.type === "space" || (config.type === "wide" && xLayout)) {
		return 10;
	}
	return 0;
}
